// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/202607192315/js/" + chunkId + "." + {"44":"07f7adc7","225":"cdadfd07","481":"1d9460a6","486":"059ccaed","770":"ce8f7770"}[chunkId] + ".0.8128943407489105.chunk.js";
};